/** Resolves a path from `public/` (or an absolute http(s) URL) for use in <img src> / href. */
export function publicUrl(relative: string): string {
  if (/^https?:\/\//.test(relative)) return relative;
  const p = relative.replace(/^\//, "");
  const base = import.meta.env.BASE_URL;
  if (base === "/") {
    return `/${p}`;
  }
  return `${base.replace(/\/$/, "")}/${p}`;
}
